import { render, staticRenderFns } from "./Preguntas_agregar.vue?vue&type=template&id=fc49a472"
import script from "./Preguntas_agregar.vue?vue&type=script&lang=js"
export * from "./Preguntas_agregar.vue?vue&type=script&lang=js"
import style0 from "./Preguntas_agregar.vue?vue&type=style&index=0&id=fc49a472&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports